import { useTranslation } from 'react-i18next';

export default function BrandStory() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-[#faf8f5]">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="relative">
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Premium%20corrugated%20cardboard%20cat%20scratching%20board%20product%20on%20a%20minimalist%20wooden%20floor%20surface%2C%20natural%20beige%20and%20kraft%20brown%20tones%2C%20soft%20diffused%20daylight%20from%20a%20nearby%20window%2C%20clean%20modern%20interior%20setting%2C%20product%20photography%20style%20with%20shallow%20depth%20of%20field%2C%20elegant%20and%20simple%20composition%2C%20warm%20natural%20atmosphere%2C%20high%20detail%20texture%20on%20the%20cardboard%20surface&width=600&height=500&seq=about-story-v3&orientation=landscape"
                alt="Koorpet 猫抓板"
                className="w-full h-72 md:h-96 object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-5 -right-4 md:-right-8 bg-white rounded-2xl p-5 w-44 md:w-52">
              <div className="text-3xl font-black text-[#C8714A] mb-1">{t('story_float_num')}</div>
              <div className="text-xs text-[#888] leading-relaxed">{t('story_float_desc')}</div>
            </div>
          </div>

          <div>
            <div className="text-[#C8714A] text-xs font-semibold tracking-widest uppercase mb-4">
              {t('story_label')}
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a1a1a] leading-tight mb-6">
              {t('story_title1')}
              <br />
              {t('story_title2')}
            </h2>
            <div className="space-y-4 text-sm text-[#666] leading-relaxed">
              <p>{t('story_p1')}</p>
              <p>{t('story_p2')}</p>
              <p>{t('story_p3')}</p>
            </div>
            <div className="mt-8 flex items-center gap-4">
              <div className="w-12 h-12 rounded-full bg-[#C8714A] flex items-center justify-center text-white text-sm font-bold flex-shrink-0">
                JY
              </div>
              <div>
                <div className="text-sm font-semibold text-[#1a1a1a]">{t('story_founder_name')}</div>
                <div className="text-xs text-[#999]">{t('story_founder_role')}</div>
              </div>
              <div className="ml-4 pl-4 border-l border-[#e8e0d8]">
                <p className="text-xs text-[#888] italic leading-relaxed max-w-xs">
                  {t('story_founder_quote')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}